import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Img } from "components";
// import PropTypes from "prop-types"; // kept for reference
// import Tabs from "@mui/material/Tabs"; // replaced with custom sidebar
// import Tab from "@mui/material/Tab"; // replaced with custom sidebar
import Footer from "components/Footer";
import { useTranslation } from "react-i18next";
import ProfileEdit from "../ProfileEdit";
import OrderDetailDelevery from "../AllTabsOption/OrderDetailDelevery";
// import { useMediaQuery } from "@mui/material"; // no longer needed
import globalRequest from "../../../utils/global/globalRequest";
import { useDispatch, useSelector } from "react-redux";
import { changeLoader } from "../../../redux/reducers/loader";
import * as APIS from "../../../utils/helper/Enum";
import { addDeleteGetLocalStorage, storageKeys } from "utils/global/localData";
import { SuccessOrderPlaced } from "popups/SuccessOrderPlaced";
import { setSnackbar } from "redux/reducers/snackbar";
import { changeTrigger, currentTrigger } from "redux/reducers/trigger";
import * as CUSTOM from "../../../utils/helper/custom";


const MyOrderDetail = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const loaderValue = useSelector(currentTrigger);
  const [successOrderPlacedOpen, setSuccessOrderPlacedOpen] = useState(false);
  const { id } = useParams();
  // const isMobile = useMediaQuery("(max-width: 990px)"); // kept for reference
  const [orderDetails, setOrderDetails] = React.useState(null);
  const [bgColor, setBgColor] = useState("bg-gray-50_02");
  const [isPaymentMode, setIsPaymentMode] = useState(false);
  let dispatch = useDispatch();

  // ── sidebar menu items – same structure as MyOrder.jsx ──────────────────────
  const menuItems = [
    {
      section: "Account",
      items: [
        { id: "wishlist",  label: t("wishlist"),             icon: "/images/Wishlist.svg",         tab: null,  path: "/wishlist" },
        { id: "orders",    label: t("myOrders"),             icon: "/images/bag.svg",               tab: 0,     path: "/my-order" },
        { id: "custom",    label: t("myCustomCakes"),        icon: "/images/custCake.svg",          tab: 5,     path: "/my-order" },
        { id: "occasions", label: t("myOccasions"),         icon: "/images/occasion.svg",          tab: 1,     path: "/my-order" },
        { id: "addresses", label: t("myAddresses"),         icon: "/images/img_location.svg",      tab: 2,     path: "/my-order" },
      ],
    },
    {
      section: "Payments",
      items: [
        { id: "wallet",   label: t("wallet"),                icon: "/images/img_wallet.svg",        tab: 3,     path: "/my-order" },
        { id: "payment",  label: t("managePaymentMenthods"), icon: "/images/img_payment-menthod.svg", tab: 4,  path: "/my-order" },
      ],
    },
    {
      section: "Settings",
      items: [
        { id: "language", label: t("preferredLanguage"),    icon: "/images/lang.svg",              tab: 6,     path: "/my-order" },
      ],
    },
  ];

  const handleSidebarClick = (item) => {
    if (item.path === "/wishlist") {
      navigate("/wishlist");
      return;
    }
    addDeleteGetLocalStorage(storageKeys.ORDER_TAB, (item.tab ?? 0).toString(), "add", "single");
    navigate(item.path);
  };

  /** get order details */
  const getOrderDetails = async (id) => {
    dispatch(changeLoader(true));
    try {
      let response = await globalRequest(
        `${APIS?.ORDER?.MY_ORDER_DETAILS}/${CUSTOM.base64Encode(id, "decode")}`,
        "get",
        {},
        {},
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        setOrderDetails(response?.data);
      }
    } catch (e) {}
    dispatch(changeLoader(false));
  };

  const sendPurchaseGaEvent = async (order_number) => {
    try {
      let response = await globalRequest(
        APIS?.ORDER?.SEND_PURCHASE_GA_EVENT,
        "post",
        { order_number, gaData: CUSTOM.getGACookieValues() },
        {},
        true
      );
      response = response?.data;
      if (response?.status == "SUCCESS") {
        console.log("GA event sent");
      }
    } catch (e) {
      console.log(e?.message);
    }
  };

  /** get order details when load page */
  useEffect(() => {
    getOrderDetails(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /** when order status update call same api */
  useEffect(() => {
    if (loaderValue == "refetchDetails") {
      getOrderDetails(id);
      dispatch(changeTrigger(""));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loaderValue]);

  /** Handle scroll */
  useEffect(() => {
    const handleScroll = () => {
      const div = document.getElementById("order-box");
      if (div) {
        const rect = div.getBoundingClientRect();
        const isVisible = rect.top <= window.innerHeight && rect.bottom >= 0;

        if (window.scrollY === 0) {
          // At the top of the page
          setBgColor("bg-gray-50_02");
        } else if (isVisible) {
          // Scrolling and div is visible
          setBgColor("bg-transparent");
        }
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
    const urlSearchParams = new URLSearchParams(window.location.search);
    if (urlSearchParams) {
      const payment_status = urlSearchParams.get("payment_status");
      if (payment_status) {
        const message = urlSearchParams.get("message");
        const order_type = urlSearchParams.get("order_type");
        if (payment_status == "success" && order_type == "gift_order") {
          CUSTOM.sendPaymentStatusGaEvent("success", "order", orderDetails?.orderData?.userId, orderDetails?.orderData?.userDetails);
          sendPurchaseGaEvent(orderDetails?.orderData?.orderNumber);
          setSuccessOrderPlacedOpen(true);
        } else {
          CUSTOM.sendPaymentStatusGaEvent("failed", "order", orderDetails?.orderData?.userId, orderDetails?.orderData?.userDetails);
          dispatch(setSnackbar({ snackbarOpen: true, snackbarMessage: message, snackbarState: "error" }));
        }
        const url = window.location.href;
        let urlEx = url.split("?");
        window.history.pushState({ html: "", pageTitle: "cart" }, "", urlEx[0]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="bg-[#FEFBFC] flex flex-col font-[Inter] items-center justify-start mx-auto w-full">
        <div className={`font-[Inter] relative w-full min-h-[100vh]`}>

          {successOrderPlacedOpen === true && orderDetails?.orderData?.orderNumber ? (
            <SuccessOrderPlaced
              closepopup={setSuccessOrderPlacedOpen}
              orderNumber={orderDetails?.orderData?.orderNumber}
            />
          ) : null}

          <ProfileEdit />

          <div
            id="order-box"
            className="flex flex-col items-center justify-center mx-auto w-full max-w-[1246px] py-[40px] md:py-5 px-[68px] md:px-5 bg-[#FEFBFC]"
          >
            <div className="w-full bg-[#FEFBFC] relative flex flex-row sm:flex-col gap-0">

              {/* ── Left Sidebar – hidden when payment mode is active ──────── */}
              {!isPaymentMode && (
                <div
                  className="w-full max-w-[280px] sm:max-w-full bg-white border-r border-gray-200 sm:border-r-0 sm:border-b sticky top-[70px] h-fit sm:relative sm:top-0 overflow-y-auto"
                  style={{ border: "2px solid #e5dcdc", borderRadius: "10px" }}
                >
                  {/* User Profile placeholder */}
                  <div className="px-6 border-b border-gray-200">
                    <div className="flex items-center gap-3"></div>
                  </div>

                  {/* Menu Sections */}
                  <div className="py-4">
                    {menuItems.map((section, sIdx) => (
                      <div key={sIdx} className="mb-6 last:mb-0">
                        <div className="px-6 mb-2">
                          <h4 className="text-[12px] font-semibold text-gray-400 uppercase tracking-wide font-[Inter]">
                            {section.section}
                          </h4>
                        </div>
                        <div className="space-y-1">
                          {section.items.map((item) => {
                            const isActive = item.id === "orders";
                            return (
                              <button
                                key={item.id}
                                onClick={() => handleSidebarClick(item)}
                                className={`w-full flex items-center gap-3 px-6 py-3 transition-all duration-200 ${
                                  isActive
                                    ? "bg-pink-50 border-l-4 border-pink-600"
                                    : "hover:bg-gray-50 border-l-4 border-transparent"
                                }`}
                              >
                                <Img
                                  src={item.icon}
                                  className={`w-5 h-5 ${isActive ? "opacity-100" : "opacity-60"}`}
                                  alt={item.label}
                                />
                                <span
                                  className={`text-[14px] font-[Inter] font-medium ${
                                    isActive ? "text-pink-600" : "text-gray-700"
                                  }`}
                                >
                                  {item.label}
                                </span>
                              </button>
                            );
                          })}
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {/* ── Main Content area – full width when payment mode ─────── */}
              <div className={`flex-1 bg-[#FEFBFC] ${isPaymentMode ? "" : "pl-5"} sm:p-5`}>
                <OrderDetailDelevery
                  orderData={orderDetails}
                  setOrderDetails={setOrderDetails}
                  onPaymentModeChange={setIsPaymentMode}
                />
              </div>
            </div>
          </div>
          <Footer className="absolute bottom-[0] flex font-nunitoregular inset-x-[0] items-center justify-center mx-auto w-full" />
        </div>
      </div>

      <style jsx>{`
        .overflow-y-auto::-webkit-scrollbar { width: 6px; }
        .overflow-y-auto::-webkit-scrollbar-track { background: #f1f1f1; }
        .overflow-y-auto::-webkit-scrollbar-thumb { background: #d1d5db; border-radius: 3px; }
        .overflow-y-auto::-webkit-scrollbar-thumb:hover { background: #9ca3af; }
        @media (max-width: 990px) { .max-w-\\[280px\\] { max-width: 100%; } }
      `}</style>
    </>
  );
};

export default MyOrderDetail;
